/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import assert from 'assert';
import {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import * as store from '@/store';
import sdk from '@/sdk';
import toast, {ToastType} from '@/components/Toast';
import {DocumentOperateType, PathParams, WizDocumentCreateDoc} from '@/interface';
import routers, {buildPath} from '@/config/routers';
import {clickNewBuildPage, feLogger} from '@/buried';
import kuPiper from '@/middleware/kuPiper';
import {BOOK_TYPE, BookType, DOC_TYPE} from '@/constants/document/doc';

import styles from './index.module.scss';
interface CreateDocumentProps {
    createDocument?: {
        type: number;
        bookType: BookType;
        parentGuid: string | null;
        docType: number;
        openInNewTab?: boolean;
        createPersonPage?: boolean;
        templateId?: string;
    };
    curDocument?: WizDocument;
}

/**
 * 创建文档组件
 *
 * @param props - 属性对象
 * @returns 返回创建文档组件
 */
function CreateDocument(props: CreateDocumentProps) {
    const intl = useIntl();
    const history = useHistory();
    const {
        createDocument,
    } = props;

    useEffect(() => {
        async function createDoc(
            type: number,
            bookType: BookType,
            parentGuid: string,
            openInNewTab?: boolean,
            createPersonPage?: boolean,
            templateId?: string
        ) {
            try {
                let repository = store.getCurRepository();
                if (createPersonPage) {
                    repository = sdk.as.userRepository as any;
                }
                assert(repository);
                const {spaceGuid, groupGuid, repositoryGuid} = repository;
                const ksServer = await sdk.getKsServer(repository);
                const date = new Date();
                const doc = {
                    position: date.valueOf(),
                    name: '',
                    parentGuid: parentGuid,
                    spaceGuid: spaceGuid,
                    groupGuid: groupGuid,
                    repositoryGuid: repositoryGuid,
                    bookType: BOOK_TYPE.IS_BOOK,
                };
                doc.position = date.valueOf();
                doc.parentGuid = parentGuid;

                let result = null;
                if (type === DOC_TYPE.SHEET) {
                    doc.name = intl.formatMessage({id: 'defaultSheetTitle'});
                    if (bookType === BOOK_TYPE.IN_BOOK) {
                        doc.bookType = bookType;
                    } else {
                        doc.bookType = BOOK_TYPE.NO_BOOK;
                    }
                    result = await ksServer.createSheet(doc as WizDocument);
                } else if (type === DOC_TYPE.PPT) {
                    doc.name = intl.formatMessage({id: 'defaultPPTTitle'});
                    if (bookType === BOOK_TYPE.IN_BOOK) {
                        doc.bookType = bookType;
                    } else {
                        doc.bookType = BOOK_TYPE.NO_BOOK;
                    }
                    result = await ksServer.createPPT(doc as WizDocument);
                } else if (type === DOC_TYPE.DATASHEET) {
                    doc.name = intl.formatMessage({id: 'defaultDataSheetTitle'});
                    if (bookType === BOOK_TYPE.IN_BOOK) {
                        doc.bookType = bookType;
                    } else {
                        doc.bookType = BOOK_TYPE.NO_BOOK;
                    }

                    if (templateId) {
                        (doc as WizDocument).templateId = templateId;
                    }
                    store.setCreateDstLoading(true);
                    result = await ksServer.createDataSheet(doc as WizDocument);
                    store.setCreateDstLoading(false);
                } else {
                    doc.name = intl.formatMessage({id: 'defaultDocumentTitle'});
                    doc.bookType = bookType;
                    result = await ksServer.createDocumentDirectory(doc as WizDocumentCreateDoc);

                    // 新建文档默认展开右侧超级助理
                    // setOpenAIChatPanelFlag(AIChatPanelExpandSource.newDoc);
                    // setAiChatShow(result.docGuid);
                }
                const userGuid = sdk.as.user?.userGuid;
                assert(userGuid);
                feLogger(clickNewBuildPage({
                    type,
                    pageId: result.docGuid,
                    repoId: result.repositoryGuid,
                    groupId: result.groupGuid,
                }));
                const params: PathParams = {
                    spaceGuid: result.spaceGuid,
                    groupGuid: result.groupGuid,
                    repositoryGuid: result.repositoryGuid,
                    docGuid: result.docGuid,
                };
                const url = buildPath(routers.Knowledge.path, params);
                store.setDocumentOperate({
                    docList: [result],
                    type: DocumentOperateType.Create,
                    data: {
                        url,
                        openInNewTab: !!openInNewTab,
                        type,
                    },
                });
                const treeData = store.getTreeData() || [];
                const updatedTreeData = [...treeData, result];
                // 更新状态
                store.setTreeData(updatedTreeData);
                // 新建逻辑改动：新窗口打开再该文件内做跳转操作，无需打开新窗口在侧边栏内做跳转操作
                if (url && openInNewTab) {
                    const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.createDocUrlJump,
                        (openInNewTab: boolean, url: string) => {
                            // if (openInNewTab) {
                            window.open(`${url}?isNewDoc=true`);
                            // } else {
                            //     history.push({
                            //         pathname: url,
                            //         search: '',
                            //         state: {
                            //             isNew: true,
                            //             isEdit: true,
                            //         },
                            //     });
                            // }
                        });
                    jumpProxy(openInNewTab, url, type);
                }
            } catch (err) {
                console.error(err);
                toast({
                    content: intl.formatMessage({id: 'errorCreateDoc'}),
                    type: ToastType.Error,
                });
                if (type === DOC_TYPE.DATASHEET) {
                    store.setCreateDstLoading(false);
                }
            }
        }
        if (createDocument && createDocument.parentGuid !== null) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            createDoc(
                createDocument.docType,
                createDocument.bookType,
                createDocument.parentGuid,
                createDocument?.openInNewTab,
                createDocument?.createPersonPage,
                createDocument?.templateId
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createDocument]);

    return (
        <div className={styles.root} />
    );
}

const CreateDocumentImpl = store.connect([
    store.KEYS.CREATE_DOCUMENT,
    store.KEYS.CUR_DOCUMENT,
])(CreateDocument);

export default CreateDocumentImpl;
